import React from 'react';
import ViewModal from '../../components/Modals/ViewModal';
import InfoField from '../../components/Shared/InfoField';
import { useBranchConfiguration } from '../../hooks/branches/useBranchConfiguration';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

const BranchViewPopup: React.FC<Props> = ({ isOpen, onClose }) => {
  const { detail } = useBranchConfiguration();

  return (
    <ViewModal
      popupOpen={isOpen}
      setPopupOpen={onClose}
      title="Detalle de Sucursal"
      maxWidth="max-w-3xl"
    >
      {/* Encabezado */}
      <div className="mb-6 flex flex-col items-start gap-1">
        <h2 className="text-gray-800 text-2xl font-bold dark:text-white">
          {detail?.name}
        </h2>

        <p className="text-gray-600 dark:text-gray-300 text-sm">
          {detail?.establishmentTypeName}
        </p>

        <span
          className={`inline-flex rounded-full px-3 py-1 text-sm font-medium ${
            detail?.active
              ? 'bg-green-500 text-white'
              : 'bg-[#DC3545] text-white'
          }`}
        >
          {detail?.active ? 'Activo' : 'Inactivo'}
        </span>
      </div>

      {/* Datos Generales */}
      <h4 className="text-gray-700 mb-2 text-base font-semibold dark:text-white">
        Datos de Identificación
      </h4>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <InfoField
          label="Código Establecimiento"
          value={detail?.establishmentCode}
        />
        <InfoField
          label="Código Punto de Venta"
          value={detail?.pointOfSaleCode}
        />

        {/* 🔹 Nuevos campos MH */}
        <InfoField
          label="Código MH Establecimiento"
          value={detail?.mhEstablishmentCode || '—'}
        />
        <InfoField
          label="Código MH Punto de Venta"
          value={detail?.mhPointOfSaleCode || '—'}
        />
      </div>

      {/* Dirección */}
      <h4 className="text-gray-700 mb-2 mt-6 text-base font-semibold dark:text-white">
        Dirección
      </h4>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <InfoField label="Departamento" value={detail?.departmentName} />
        <InfoField label="Municipio" value={detail?.municipalityName || '—'} />
      </div>
      <InfoField label="Dirección Complementaria" value={detail?.complement} />

      {/* Botón de cierre */}
      <button
        onClick={onClose}
        className="mt-8 w-full rounded-md bg-primary px-4 py-2 text-white hover:bg-opacity-90"
      >
        Cerrar
      </button>
    </ViewModal>
  );
};

export default BranchViewPopup;
